import { castArray } from 'vtils'

const parseJson = value => {
  try {
    return JSON.parse(value)
  } catch {
    return {}
  }
}

/**
 * @param {Record<string, string | string[] | { key: string | string[], json?: boolean, default?: any, transformer?: (value: string) => any }>} keys
 */
export function mapQuery(keys) {
  return {
    computed: Object.keys(keys).reduce((res, key) => {
      res[key] = function () {
        const kkk = keys[key]
        const kk =
          typeof kkk === 'string' || Array.isArray(kkk)
            ? {
                key: kkk,
              }
            : kkk
        for (const k of castArray(kk.key)) {
          if (this.$route.query[k] != null) {
            return kk.transformer
              ? kk.transformer(this.$route.query[k])
              : kk.json
              ? parseJson(this.$route.query[k])
              : this.$route.query[k]
          } else if (this.$route.params[k] != null) {
            return kk.transformer
              ? kk.transformer(this.$route.query[k])
              : kk.json
              ? parseJson(this.$route.params[k])
              : this.$route.params[k]
          }
        }
        return kk.default
      }
      return res
    }, {}),
  }
}
